import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './reducers'
import thunk from 'redux-thunk'
import createSagaMiddleware from 'redux-saga'

import { watchConfig } from './sagas'
import { watchScore } from './sagas'
import { watchSocket } from './sagas'
import { watchLead } from './sagas'

const sagaMiddleware = createSagaMiddleware()

export const store = configureStore({
  reducer: rootReducer,
  middleware: [thunk, sagaMiddleware],
  devTools: process.env.NODE_ENV !== 'production'
})

sagaMiddleware.run(watchConfig)
sagaMiddleware.run(watchScore)
sagaMiddleware.run(watchSocket)
sagaMiddleware.run(watchLead)
